import src from "IMAGE";
export default { src, width: 688, height: 531, blurWidth: 0, blurHeight: 0};
